import { render, staticRenderFns } from "./Devis.vue?vue&type=template&id=48be0d6b&"
import script from "./Devis.vue?vue&type=script&lang=js&"
export * from "./Devis.vue?vue&type=script&lang=js&"
import style0 from "./Devis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports